import { useNavigate, useParams } from 'react-router'
import { useEmailCampaign } from '@/hooks/useEmailCampaigns'
import CampaignDetailView from '@/pages/clients/ClientProviders/CampaignDetailView'

export default function OutreachCampaignDetailPage() {
  const { clientId, campaignId } = useParams<{ clientId: string; campaignId: string }>()
  const navigate = useNavigate()

  if (!clientId || !campaignId) return null

  return (
    <CampaignDetailPageContent clientId={clientId} campaignId={campaignId} onBack={() => navigate('..')} />
  )
}

interface CampaignDetailPageContentProps {
  clientId: string
  campaignId: string
  onBack: () => void
}

function CampaignDetailPageContent({ clientId, campaignId, onBack }: CampaignDetailPageContentProps) {
  const { campaign, loading } = useEmailCampaign(clientId, campaignId)

  if (loading || !campaign) return null

  return <CampaignDetailView clientId={clientId} campaign={campaign} onBack={onBack} />
}
